import * as auth from "./auth.requests";
import * as agent from "./agent.requests"
import * as form from "./form.requests"
import * as admin from "./admin.requests"

export default {auth, agent, form, admin}